/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Ph_Ma_Don_Noi_Bo_DescInputs */

const vi_station_voice_ph_ma_don_noi_bo_desc = /** @type {(inputs: Station_Voice_Ph_Ma_Don_Noi_Bo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn nội bộ (đọc từng chữ số)`)
};

/**

* @param {Station_Voice_Ph_Ma_Don_Noi_Bo_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_ph_ma_don_noi_bo_desc = /** @type {((inputs?: Station_Voice_Ph_Ma_Don_Noi_Bo_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Ph_Ma_Don_Noi_Bo_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_ph_ma_don_noi_bo_desc(inputs)
});